function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M17.828 18.889l1.06-1.061-5.833-5.834 5.834-5.833-1.06-1.061-5.835 5.834L6.161 5.1 5.1 6.16l5.833 5.834L5.1 17.828l1.06 1.06 5.834-5.833 5.834 5.834z",
  fill: "currentColor"
});

function SvgCloseIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none"
  }, props), _ref);
}

export default SvgCloseIcon;